import styled from '@emotion/styled/macro';

import { Root as ButtonRoot } from 'components/buttons/styles';

export const ModalRoot = styled.div(() => ({
  outline: 'none',
}));

export const ModalControls = styled.div((props) => ({
  // @ts-ignore
  [ButtonRoot]: {
    minWidth: 'unset',
    width: 20,
    height: 20,
    padding: 4,
    span: {
      lineHeight: 0.5,
    },
  },
}));

export const PanelContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 20,
  maxWidth: 420,
  padding: '0 12px 12px 12px',
}));

export const ContentContainer = styled.div(() => ({
  minWidth: 300,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 15,
  alignItems: 'center',
}));

export const Question = styled.div((props) => ({
  fontWeight: 600,
  fontSize: 16,
  color: props.theme.colors.primary,
}));

export const Caption = styled.div((props) => ({
  fontWeight: 400,
  fontSize: 13,
  color: props.theme.colors.primary,
  textAlign: 'center',
}));

export const Delimeter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const Buttons = styled.div(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 16,
}));

export const Image = styled.img(() => ({}));
